import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { UNAUTHORIZED_EVENT, isAuthenticated } from "@/api/client";
import { LoginPage } from "@/components/LoginPage";
import { AppLayout } from "@/components/layout/AppLayout";
import { ClientDetailPage } from "@/pages/ClientDetailPage";
import { ClientsPage } from "@/pages/ClientsPage";
import { CompliancePage } from "@/pages/CompliancePage";
import { DashboardPage } from "@/pages/DashboardPage";
import { ExpensesPage } from "@/pages/ExpensesPage";
import { InvoiceDetailPage } from "@/pages/InvoiceDetailPage";
import { BooksPage } from "@/pages/BooksPage";
import { MoneyPage } from "@/pages/MoneyPage";
import { InvoicesPage } from "@/pages/InvoicesPage";
import { MailPage } from "@/pages/MailPage";
import { NewClientPage } from "@/pages/NewClientPage";
import { NewInvoicePage } from "@/pages/NewInvoicePage";
import { NewReceiptPage } from "@/pages/NewReceiptPage";
import { OperationsPage } from "@/pages/OperationsPage";
import { PaymentsPage } from "@/pages/PaymentsPage";
import { ReceiptsPage } from "@/pages/ReceiptsPage";
import { ReportsPage } from "@/pages/ReportsPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { VesselsPage } from "@/pages/VesselsPage";

export default function App() {
  const [signedIn, setSignedIn] = useState(isAuthenticated);
  const queryClient = useQueryClient();

  useEffect(() => {
    const onUnauthorized = () => {
      queryClient.clear();
      setSignedIn(false);
    };
    window.addEventListener(UNAUTHORIZED_EVENT, onUnauthorized);
    return () => window.removeEventListener(UNAUTHORIZED_EVENT, onUnauthorized);
  }, [queryClient]);

  if (!signedIn) {
    return <LoginPage onLogin={() => setSignedIn(true)} />;
  }
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

/** The signed-in routes; exported so tests can mount them in a MemoryRouter. */
export function AppRoutes() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="invoices" element={<InvoicesPage />} />
        <Route path="invoices/new" element={<NewInvoicePage />} />
        <Route path="invoices/:invoiceId" element={<InvoiceDetailPage />} />
        <Route path="operations" element={<OperationsPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="expenses" element={<ExpensesPage />} />
        <Route path="money" element={<MoneyPage />} />
        <Route path="books" element={<BooksPage />} />
        <Route path="compliance" element={<CompliancePage />} />
        <Route path="mail" element={<MailPage />} />
        <Route path="receipts" element={<ReceiptsPage />} />
        <Route path="receipts/new" element={<NewReceiptPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="clients/new" element={<NewClientPage />} />
        <Route path="clients/:clientId" element={<ClientDetailPage />} />
        <Route path="vessels" element={<VesselsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
